import { IMAGE_CHANGE } from '../../action-types/ui/imageChange';

export const imageChange = isChange => ({
  type: IMAGE_CHANGE,
  isChange,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/imageChange.js